import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AppGlobalsService } from '../app-globals.service';
import { CONTACTUS_REPORT_PROBLEM, CONTACTUS_SUGGESTION } from '../app.component';
import { Router } from '@angular/router';
import { BreakpointService, BreakpointState } from '../breakpoint.service';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.css']
})
  export class SiteFooterComponent {

  today = new Date();

  reportAProblem = CONTACTUS_REPORT_PROBLEM;
  suggestChanges = CONTACTUS_SUGGESTION;
  private _subscription;
  isHandset: boolean = false;

  constructor(private appGlobals: AppGlobalsService,
              private router: Router,
              private breakpointService: BreakpointService
              ) { }

  ngOnInit() {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )

  }

  launchContactForm(title: string): void {
    this.appGlobals.openContactRequest(title);
  }

  openJoinNow(): void {
    this.appGlobals.openJoinNowForm();
  }

  redirectToAttributions(): void {
    this.router.navigate(['/attribution']);
  }

  redirectToAccessibility(): void {
    this.router.navigate(['/accessibility']);
  }

  redirectToAbout(): void {
    this.router.navigate(['/about']);
  }

  redirectToTakedown(): void {
    this.router.navigate(['/takedown']);
  }
}
